<template>
    <button :class="{ disabled : isDisabled }" @click="onClick()">
        <i :title="$t(label)" :class="icon"></i>
        <span v-if="showButtonName" class="ml-1">{{ $t(label) }}</span>
    </button>
</template>

<script>

const typeMapping = {
    'add': {
        label: "btn.basic.add",
        icon: "fa fa-fw fa-lg fa-plus",
    },
    'edit': {
        label: "btn.basic.edit",
        icon: "fa fa-pencil-alt",
    },
    'delete': {
        label: "btn.basic.delete",
        icon: "fa fa-trash",
        precondition: function($this) {
            return $this.$modal.confirmModal('msg.delete.alert');
        }
    },
    'view': {
        label: "btn.basic.view",
        icon: "fa fa-eye",
    },
    'export': {
        label: "btn.basic.export",
        icon: "fa fa-file-export",
    },
    'save': {
        label: "btn.basic.save",
        icon: "fa fa-fw fa-lg fa-save"
    },
    'cancel': {
        label: "btn.basic.cancel",
        icon: "fa fa-times",
        class: ''
    },
    'check': {
        label: "btn.basic.save",
        icon: "fa fa-check",
        class: ''
    },
    'showEntity': {
        label: "btn.basic.view",
        icon: "fa fa-file-alt",
        class: ''
    },
    'log': {
        label: "btn.basic.view",
        icon: "fa fa-file-download text-primary"
    },
    'downloadFile': {
        label: "btn.basic.downloadFile",
        icon: "fa fa-file-download"
    },
    'uploadFile': {
        label: "btn.basic.uploadFile",
        icon: "fa fa-file-upload"
    },
    'changePwd': {
        label: "btn.basic.changePwd",
        icon: "fa fa-key"
    }
};

export default {
    name: "mmf-button",
    props: {
        'type': String,
        'disabled': Boolean,
        'showName': Boolean
    },
    data: function() {
        return {
            bType: this.type,
            showButtonName: this.showName
        }
    },
    computed: {
        isDisabled: function() {
            return this.disabled
        },
        icon: function() {
            return typeMapping[this.bType].icon;
        },
        label: function() {
            return typeMapping[this.bType].label;
        }
    },
    methods: {
        onClick() {
            var self = this;
            var precondition = typeMapping[this.bType].precondition;
            
            if(!(this.isDisabled)) {
                if (precondition) {
                    precondition(this).then(() => self.$emit('click'));
                }
                else {
                    this.$emit('click');
                }
            }
        }
    }
}
</script>